import { isValidPhoneNumber } from "libphonenumber-js";

export const validatePhoneNumber = (phoneNumber: string, regionCode: any) => {
  return isValidPhoneNumber(phoneNumber, regionCode);
};
export const validateSecurityPinCode = (pinCode: string) => {
  return pinCode.length === 6;
};
export const validateOtpCode = (code: string) => {
  return code.length === 4;
};
export const validateNationalId = (nationalId: string) => {
  return nationalId.length === 10;
};
export const validateName = (name: string) => {
  return name.length <= 25;
};
